import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminCloseChat = (id) => {
  return axiosClient.post(`/api/admin/im/close/${id}`).then((r) => r.data);
};
